console.log('hello world');

document.querySelector('input[type="hidden"][name="id"]').addEventListener('change', () => {
  const input = Array.from(document.querySelectorAll('fieldset input:checked'))
    .map((e) => e.nextSibling.nextSibling.innerText.split('\n')[0])
    .filter((e) => e);
  //console.log(input);

  //updateVariantData();
});

function updateDetailsElement() {
  //change energy consumption to being always open at default
  const details = document.querySelector('#Details-collapsible-row-0-template--24414083416412__main');
  details.setAttribute('open', '');
  const summary = details.querySelector('summary');
  summary.setAttribute('aria-expanded', 'true');
}

window.addEventListener('load', function () {
  //updateVariantData();
  powerCalculationInit();
  updateDetailsElement();

  const button = document.getElementById('rent_inquiry');
  button.onclick = () => {
    const input = this.document.getElementsByClassName(
      'po-option--type-text po-option--type-datepicker-input flatpickr-input'
    )[0];

    const mail = this.document.getElementById('customer_email').textContent.trim();
    if (mail) console.log('yes mail');
    console.log('email: ', mail);

    let date = 'Non Selected';
    if (input.value) date = input.value;
    console.log('date: ', date);

    Shopify.analytics.publish('rent_inquiry', { mail: mail, date: date });

    //const text = `Eine neue Mietanfrage von ${mail} für den Zeitraum : ${date}`;
    // fetch('https://api.sendgrid.com/v3/mail/send', {
    //   method: 'POST',
    //   headers: {
    //     Authorization: 'Bearer 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',
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     personalizations: [
    //       {
    //         to: [
    //           {
    //             email: 'office@satoaki.dev',
    //           },
    //         ],
    //       },
    //     ],
    //     from: {
    //       email: 'se@desk-sicherheit.de',
    //     },
    //     subject: 'Miet Anfrage',
    //     content: [
    //       {
    //         type: 'text/plain',
    //         value: text,
    //       },
    //     ],
    //   }),
    // });
  };
});

function powerCalculationInit() {
  const inputs = document.querySelector('.gpo-hidden-inputs').querySelectorAll('input[type="hidden"]');
  const options = {};

  inputs.forEach((input) => {
    // Create a MutationObserver instance for each input
    const name = input.getAttribute('data-field-name'); // Get the name attribute
    if (name) {
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const newValue = input.getAttribute('value'); // Get the new value
            // Update the dictionary
            options[name] = newValue;

            updatePower(options);
          }
        });
      });

      // Observe the element for attribute changes
      observer.observe(input, {
        attributes: true, // Monitor attribute changes
        attributeFilter: ['value'], // Focus on the "value" attribute
      });

      // Initialize the dictionary with the current value
      const name = input.getAttribute('data-field-name');
      const initialValue = input.getAttribute('value');
      options[name] = initialValue;
    }
  });

  updatePower(options);
}

function getBasePowerConsumption() {
  const variantID = document.getElementsByName('id')['0'].value;
  const variantData = JSON.parse(
    document.getElementById('variant_meta_data').textContent.trim().replaceAll('\n', '<br/>')
  );
  return variantData[variantID].energy_usage;
}

function updatePower(options) {
  const basePower = getBasePowerConsumption();
  console.log('options: ', options);
  const div_energy = document.querySelector('#variant-details');

  let variable = '';
  let sum = parseFloat(basePower);
  for (const [key, value] of Object.entries(options)) {
    if (value) {
      const amount = getConsumptionValue(key, value);
      if (amount >= 0) {
        sum += amount;
        variable += `<div><span>${key}</span><span>${amount.toFixed(1)} watt</span></div>`;
      }
    }
  }

  // div_energy.innerHTML = basePower + ' kWh' ?? 'No Data';
  div_energy.innerHTML = `
  <style type="text/css">
    #variant-power {

    }
    #variant-power > div {
      display: flex;
      justify-content: space-between;
    }
    .variant-divider{
      background: var(--bss-po-color-border);
      height: 1px;
    }
  </style>
  <div id='variant-power' style="padding-top: .5em">
    <div><span>Base Tower</span><span>${basePower} watt</span></div>
    ${variable}
    <div style="height: .2em"></div>
    <div class='variant-divider'></div>
    <div style="height: .2em"></div>
    <div><span><strong>Sum</strong></span><span>${sum.toFixed(1)} watt</span></div>
    ${calculateRuntime(options.Battery, sum)}
  </div>
  `;
}

const psuOptions = [-100.0, -5000.0, -3680.0];
const vrOptions = [10.0, 16.0, 24.0];
const aiComputerOptions = [60.0];
const aiOptions = [8.0, 25.0, 12.0, 16.0, 40.0, 25.0, 12.0, 16.0, 40.0, 25.0, 12.0, 16.0, 40.0, 25.0, 12.0, 16.0];
const voltage = 24;

function getConsumptionValue(key, value) {
  function psuVal2int(string) {
    if (string.includes('Solar')) return 0;
    if (string.includes('Brennstoff')) return 1;
    if (string.includes('Land')) return 2;
    console.log('NO PSU found: ', string);
  }
  function vrVal2int(string) {
    if (string.includes('Heik')) return 0;
    if (string.includes('NX')) return 1;
    if (string.includes('Milestone')) return 2;
    console.log('NO VR found: ', string);
  }
  switch (key) {
    case 'Power':
      return psuOptions[psuVal2int(value)];
    case 'Recorder':
      return vrOptions[vrVal2int(value)];
    case 'AI Computer':
      return aiComputerOptions[0];
    default:
      return -1;
      const selections = value.split(',');
      let sum = 0;
      selections.forEach((e) => {
        let s = e.split('(');
        s = s[s.length - 1];
        sum += aiOptions[parseInt(s.substring(0, s.length - 1) - 1)];
      });
      return sum;
  }
}

function calculateRuntime(battery, watts) {
  if (!battery) return '';
  let ampHours = parseInt(battery.split('AH')[0]);

  if (ampHours <= 0 || voltage <= 0 || watts <= 0) {
    console.log('All inputs must be positive numbers.');
    return '';
  }
  const batteryCapacityWh = ampHours * voltage;
  const runtime = batteryCapacityWh / watts;
  return `
  <div style="padding-top: .5em">
    <span>Runtime on Outage:</span>
    <span><strong>~${runtime.toFixed(1)}</strong> h</span>
  </div>`;
}
